<template v-if="$store.state.isAuthenticated">
    <MainLayout/>
</template>

<script>
    // @ is an alias to /src
    import MainLayout from "../components/MainLayout";
    export default {
        name: 'Home',
        components: {
            MainLayout
        }
    }
</script>
